if (typeof window.performance === "object") {
  if (window.performance.now) {
    module.exports = function () {
      return window.performance.now();
    };
  } else if (window.performance.webkitNow) {
    module.exports = function () {
      return window.performance.webkitNow();
    };
  }
} else if (Date.now) {
  module.exports = Date.now;
} else {
  module.exports = function () {
    return new Date().getTime();
  };
}